// MainLayout.js

import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from './components/AppNavbar';
import Header from './components/Header';
import SideMenu from './components/SideMenu';
import AppTheme from './shared-theme/AppTheme';
import Overview from './pages/Overview';
import Hazards from './pages/Hazards';
import Scenarios from './pages/Scenarios';
import Networks from './pages/Networks'; // Now renders StatisticsTab
import Settings from './pages/Settings';
import Feedback from './pages/Feedback';
import PrivacyPolicy from './pages/PrivacyPolicy';
import About from './pages/About';
import PasswordResetConfirm from './pages/PasswordResetConfirm';
import Report from './components/Report';
import ReportScenarios from './components/ReportScenarios';
import ScenarioComparisonReport from './components/ScenarioComparisonReport';
import { SimulationProvider } from './components/contexts/SimulationContext';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function MainLayout(props) {
  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      {/* --- MODIFICATION: Wrap the layout with the provider INSIDE the theme --- */}
      <SimulationProvider>
        <Box sx={{ display: 'flex' }}>
          <SideMenu />
          <AppNavbar />
          {/* Main content */}
          <Box
            component="main"
            sx={(theme) => ({
              flexGrow: 1,
              backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
              overflow: 'auto',
            })}
          >
            <Stack
              spacing={2}
              sx={{
                alignItems: 'center',
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
              }}
            >
              <Header />
              <Routes>
                <Route path="/" element={<Overview />} />
                <Route path="/hazards" element={<Hazards />} />
                <Route path="/scenarios" element={<Scenarios />} />
                <Route path="/statistics" element={<Networks />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/feedback" element={<Feedback />} />
                <Route path="/about" element={<About />} />
                <Route path="/report" element={<Report />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/password-reset-confirm/:uidb64/:token" element={<PasswordResetConfirm />} />
                <Route path="/report/scenarios/:scenarioId" element={<ReportScenarios />} />
                <Route path="/report/compare/:baseScenarioId/:comparisonScenarioId" element={<ScenarioComparisonReport />} />
              </Routes>
            </Stack>
          </Box>
        </Box>
      </SimulationProvider>
    </AppTheme>
  );
}